<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<div
  class="future-product-price-container-st"
  *ngIf="isVisibleFuturePrice">
  <div
    class="future-product-price-container">
    <render-wysiwyg
      class="future-product-price"
      [html]="getTextFutureProductPrice(false)">
    </render-wysiwyg>
    <render-wysiwyg
      *ngIf="product.priceInfo?.prewarming?.localePriceWithCurrency"
      class="locale-future-product-price"
      [html]="getTextFutureProductPrice(true)">
    </render-wysiwyg>
    <render-wysiwyg
      class="product-prewarming-discount-rate"
      [html]="getTextProductPrewarmingDiscountRate()">
    </render-wysiwyg>
    <render-wysiwyg
      class="product-prewarming-description"
      [html]="getTextProductPrewarmingDescription()">
    </render-wysiwyg>
  </div>
</div>

<!-- Precio -->
<ng-container
  *ngIf="!isVisibleTriplePriceRemark; else triplePriceRemark">
  <div
    *ngIf="product.priceInfo"
    class="product-price-container">
    <div class="product-price-current-container">
      <render-wysiwyg
        class="product-price-current"
        [html]="getTextProductPrice(false, product | isCurrentPriceOnSale:this.piece!.settings!.general.displayOldProductPrices)"
        [piece]="piece">
      </render-wysiwyg>
      <render-wysiwyg
        *ngIf="product.priceInfo?.localePriceWithCurrencySymbol"
        class="locale-product-price"
        [html]="getTextProductPrice(true, product | isCurrentPriceOnSale:this.piece!.settings!.general.displayOldProductPrices)"
        [piece]="piece">
      </render-wysiwyg>
      <!-- descuento % -->
      <render-wysiwyg
        *ngIf="(isVisibleProductPriceDiscount && !isVisibleOriginalPrice) || (isVisibleDoublePriceDiscount || isVisibleTriplePriceDiscount)"
        class="product-price-discount"
        [html]="getProductPriceDiscountTextFormat()"
        [piece]="piece">
      </render-wysiwyg>
    </div>

  <!-- Oferta -->
    <div
      *ngIf="product.priceInfo?.oldPriceWithCurrencySymbol"
      class="price-locale-container">
        <div
          class="strikethrough">
          <render-wysiwyg
            *ngIf="isVisibleOldPrice"
            class="old-product-price"
            [html]="getTextOldProductPrice(false)"
            [piece]="piece">
          </render-wysiwyg>
          <render-wysiwyg
            *ngIf="isVisibleOldPrice && product.priceInfo?.oldLocalePriceWithCurrencySymbol"
            class="old-locale-product-price"
            [html]="getTextOldProductPrice(true)"
            [piece]="piece">
          </render-wysiwyg>
        </div>
        <render-wysiwyg
          *ngIf="isVisibleTriplePriceDiscount"
          class="product-price-locale-discount"
          [html]="getProductPriceDiscount()"
          [piece]="piece">
        </render-wysiwyg>

        <!-- Precio de temporada -->
        <div
          class="price-original-container strikethrough">
          <render-wysiwyg
            class="original-product-price"
            *ngIf="isVisibleOriginalPrice"
            [html]="getTextOriginalProductPrice()"
            [piece]="piece">
          </render-wysiwyg>
          <render-wysiwyg
            *ngIf="isVisibleOriginalPrice && product.priceInfo?.oldLocalePriceWithCurrencySymbol"
            class="old-locale-product-price"
            [html]="getTextOldProductPrice(true)"
            [piece]="piece">
          </render-wysiwyg>
        </div>
    </div>

    <ng-container *ngIf="isVisiblePriceDescription">
      <render-wysiwyg
        *ngIf="piece?.settings?.general?.productPriceDescription"
        [html]="piece!.settings!.general!.productPriceDescription">
      </render-wysiwyg>
    </ng-container>
  </div>
</ng-container>
<ng-template #triplePriceRemark>
  <div
    *ngIf="product.priceInfo"
    class="product-price-container">
    <div
      class="product-price-current-container">
      <render-wysiwyg
        class="product-price-current"
        [html]="getTextProductPrice(false, true)"
        [piece]="piece">
      </render-wysiwyg>
    </div>
  </div>
</ng-template>

<render-wysiwyg
  *ngIf="isVisibleProductPromotionDates && (isVisiblePrewarmingDescription || isVisibleTriplePriceRemark)"
  class="product-promotion-description"
  [html]="getTextProductPromotionDescription()">
</render-wysiwyg>

